import { Converter } from '../types/converter';

export const magnetomotiveForceConverter: Converter = {
  id: 'magnetomotiveForce',
  name: 'Magnetomotive Force Converter',
  icon: 'Magnet',
  categories: ['magnetism'],
  units: [
    { name: 'Ampere turn', symbol: 'At', factor: 1 },
    { name: 'Kiloampere turn', symbol: 'kAt', factor: 1000 },
    { name: 'Milliampere turn', symbol: 'mAt', factor: 0.001 },
    { name: 'Abampere turn', symbol: 'abAt', factor: 10 },
    { name: 'Gilbert', symbol: 'Gi', factor: 0.7957747151 }
  ]
};
